import {
  IBriefCampaignInfluencerSearchRequestV2,
  ICampaignPendingReviewAction,
  ICampaignPendingReviewActionCount,
} from "@shared/lib/types/briefCampains";

export type CampaignPendingReviewFlag = keyof ICampaignPendingReviewAction;

export const AGENCY_CAMPAIGN_PENDING_REVIEW_GROUPS: {
  id: CampaignPendingReviewFlag;
  label: string;
}[] = [
  { id: "editsRequestedOnScript", label: "Script Review" },
  { id: "editsRequestedOnDraft", label: "Draft Review" },
  { id: "completedLive", label: "Live Completed" },
  { id: "editsRequestedOnBrief", label: "Brief Review" },
  { id: "editsRequestedOnLive", label: "Live Review" },
  { id: "pendingApprovalOnBrief", label: "Brief Approval" },
  { id: "pendingApprovalOnScript", label: "Script Approval" },
  { id: "pendingApprovalOnDraft", label: "Draft Approval" },
  { id: "pendingApprovalOnLive", label: "Live Approval" },
  { id: "completedBrief", label: "Brief Completed" },
  { id: "completedScript", label: "Script Completed" },
  { id: "completedDraft", label: "Draft Completed" },
  { id: "approvedOnBrief", label: "Brief Approved" },
  { id: "approvedOnScript", label: "Script Approved" },
  { id: "approvedOnDraft", label: "Draft Approved" },
  { id: "approvedOnLive", label: "Live Approved" },
];

export function getCampaignPendingReviewChips(
  counts?: ICampaignPendingReviewActionCount
): { id: CampaignPendingReviewFlag; label: string; count: number }[] {
  if (!counts) {
    return [];
  }

  return AGENCY_CAMPAIGN_PENDING_REVIEW_GROUPS.map((group) => ({
    id: group.id,
    label: group.label,
    count: counts[group.id] ?? 0,
  })).filter((group) => group.count > 0);
}

export function getCampaignPendingReviewSearchParams(
  flag: CampaignPendingReviewFlag | null
): Pick<IBriefCampaignInfluencerSearchRequestV2, "pendingReviewActions"> {
  if (!flag) {
    return {};
  }

  return {
    pendingReviewActions: {
      agency: { [flag]: true },
    },
  };
}

export function getCampaignPendingReviewSummary(
  counts?: ICampaignPendingReviewActionCount
) {
  const chips = getCampaignPendingReviewChips(counts);
  const changeCount =
    counts?.total ?? chips.reduce((sum, chip) => sum + chip.count, 0);

  return {
    chips,
    changeCount,
    creatorCount: counts?.briefInfluencerCount,
  };
}
